/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */
import { ColorSwatch } from './color';
export var DefaultColorSwatch = ColorSwatch([
    ['black', 0x000000],
    ['gray', 0x808080],
    ['white', 0xFFFFFF],
    ['red', 0xD33115],
    ['orange', 0xE27300],
    ['yellow', 0xFCC400],
    ['green', 0x68BC00],
    ['cyan', 0x16A5A5],
    ['blue', 0x009CE0],
    ['purple', 0x7B64FF],
    ['magenta', 0xFA28FF],
    ['violet', 0x7D2187]
]);
//# sourceMappingURL=swatches.js.map